/**
 * Flattens whatever Chargebee, the gateway or WebKit rejected with into one
 * searchable string. Three shapes reach us: a real `Error` (or `DOMException`,
 * whose `name` carries the only useful part — `InvalidAccessError`), a bare
 * string, and Chargebee's own `{ error_code, message, ... }` objects, sometimes
 * wrapped one level deep in `error` / `cause`.
 */
export const readChargebeeErrorText = (error: unknown, depth = 1): string => {
  if (typeof error === 'string') return error;
  if (error === null || typeof error !== 'object') return '';

  const record = error as Record<string, unknown>;
  const own = ['name', 'message', 'displayMessage', 'error_code', 'code', 'error_msg', 'error_text', 'status']
    .map((key) => record[key])
    .filter((part): part is string | number => typeof part === 'string' || typeof part === 'number');

  const nested =
    depth > 0
      ? ['error', 'cause', 'active_payment_attempt'].map((key) => readChargebeeErrorText(record[key], depth - 1))
      : [];

  return [...own, ...nested].filter(Boolean).join(' ');
};
